export const formatMatchCount = (count: number): string =>
  `${count} match${count === 1 ? '' : 'es'}`;

export const formatDocCount = (count: number): string =>
  `${count} ${count === 1 ? 'document' : 'documents'}`;

export const parseCalendarYearRange = (input: string): { min?: number; max?: number } => {
  const trimmed = input.trim();
  if (!trimmed) return {};
  if (trimmed.includes('-')) {
    const [minStr, maxStr] = trimmed.split('-').map((s) => s.trim());
    const min = Number(minStr);
    const max = Number(maxStr);
    return {
      min: Number.isFinite(min) ? min : undefined,
      max: Number.isFinite(max) ? max : undefined,
    };
  }
  const single = Number(trimmed);
  return Number.isFinite(single) ? { min: single, max: single } : {};
};
